import { IndividualAccount } from '@/features/account/IndividualAccount';

/** `/me` - the individual person's account (FR-09). */
export function AccountPage() {
  return <IndividualAccount />;
}
